export default __webpack_public_path__ + "static/media/T840_A_BD.0764d9c1.pdf";